<template>
  <v-container v-if="user">
    <v-row>
      <v-col cols="12" md="6" class="px-4 mt-n3">
        <v-row dark align="end">
          <div class="display-1">SMS</div>
          <v-spacer></v-spacer>
          <Saldo :saldo="saldo" />
        </v-row>
        <v-row class="mt-1">
          <v-textarea
            class="mr-0"
            rounded
            autofocus
            clearable
            auto-grow
            solo
            counter
            name="input-7-1"
            label="Skriv din besked her..."
            v-model="message"
            hint="Du kan automatisk indflette modtagernes fornavne ved at skrive '%navn%'.Eksempel: 'Hej %navn%. Kommer du i dag?'"
          ></v-textarea>
        </v-row>

        <span class="subheading">Afsender:</span>

        <v-radio-group
          class="mt-n1 mb-n4"
          v-model="afsender"
          :mandatory="false"
          :row="$vuetify.breakpoint.mdAndUp"
        >
          <v-radio label="Say-IT" value="Say-IT"></v-radio>
          <v-radio
            v-if="user.number"
            :label="`Dit nummer (${user.number})`"
            :value="user.number"
          ></v-radio>
        </v-radio-group>
        <span class="subheading">Sendes:</span>

        <v-radio-group
          class="mt-n1 mb-n4"
          v-model="sendDate"
          :mandatory="false"
          :row="$vuetify.breakpoint.mdAndUp"
        >
          <v-radio label="Nu" value="now"></v-radio>
          <v-radio label="Senere" value="scheduled"></v-radio>
        </v-radio-group>

        <v-row v-if="sendDate !== 'now'" class="mt-n4">
          <VueCtkDateTimePicker
            v-model="date"
            :overlay="true"
            locale="da"
            format="YYYY-MM-DD HH:mm"
            minuteInterval="5"
            :noButtonNow="true"
            :minDate="formatDate"
            label="Vælg dato og tid"
          />
        </v-row>

        <v-row>
          <v-btn class="mt-1 primary" @click="send" rounded :loading="loading"
            >Send!</v-btn
          ></v-row
        >

        <v-row>
          <MessagePreview
            :warning="warning"
            :message="message"
            :selected="selected"
            :afsender="afsender"
            :loading="loading"
            :tags="tags"
            :user="user"
          />
        </v-row>
        <v-row v-if="this.debug">
          <v-switch dense v-model="showJson"></v-switch>
          <code v-show="showJson">{{ json }}</code>
        </v-row>
      </v-col>
      <v-col cols="12" md="6" class="px-0">
        <v-row v-if="showSearch">
          <v-spacer />
          <v-col cols="12" md="8">
            <v-text-field
              label="Hvem leder du efter?"
              clearable
              solo
              rounded
              dense
              v-model="filterText"
              prepend-inner-icon="mdi-magnify"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col class="mx-n" cols="12">
            <v-simple-table dense class="mt-5 elevation-4" width="100%">
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left mr-n4" width="10%" @click="selectAll">
                      Vælg
                    </th>
                    <th class="text-left" width="49%">Navn</th>
                    <th class="text-right" width="36%">Nummer</th>
                  </tr>
                </thead>
                <tbody v-if="activePersons">
                  <tr v-for="(person, index) in activePersons" :key="index">
                    <td width="10%">
                      <v-checkbox
                        class="mb-n6 mt-n1 mr-n4"
                        dense
                        v-model="selected"
                        :value="person"
                      ></v-checkbox>
                    </td>
                    <td width="49%">
                      {{ person.firstName }} {{ person.lastName }}
                    </td>
                    <td width="36%" class="text-right">
                      {{ person.number | filterPhone }}
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-col>
        </v-row>
        <v-btn x-small @click="selectAll">Vælg alle</v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import axios from "axios";
import MessagePreview from "@/components/MessagePreview.vue";
import Saldo from "@/components/Saldo.vue";
import * as firebase from "firebase/app";
import { db } from "../main";
import VueCtkDateTimePicker from "vue-ctk-date-time-picker";
import "vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css";
import moment from "moment";

export default {
  name: "SMS",
  components: {
    MessagePreview,
    Saldo,
  },
  data() {
    return {
      sendDate: "now",
      date: null,
      date2: new Date().toISOString(),
      saldo: null,
      test: { lars: true },
      showSearch: false,
      filterText: "",
      debug: false,
      tags: [
        {
          tag: "%navn%",
          sub: "firstName",
        },
        {
          tag: "%efternavn%",
          sub: "lastName",
        },
        {
          tag: "%id%",
          sub: "id",
        },
      ],
      loading: null,
      showJson: false,

      warning:
        "\n---\nOBS: Du kan ikke svare på beskeder fra 'Say-IT'. Skriv til Gert i stedet.",
      message: "",
      afsender: "Say-IT",
      selected: [],
    };
  },
  watch: {
    // whenever question changes, this function will run
    message: function() {
      //console.log(newValue);
      localStorage.message = this.message;
    },
  },
  created() {
    if (
      this.$store.getters.getList == null ||
      this.$store.getters.getList == undefined ||
      this.$store.getters.getList.length < 1
    ) {
      this.$store.dispatch("activePersons");
    }
    this.getSaldo();
    if (localStorage.message) {
      if (localStorage.message == null) {
        //console.log(localStorage.message) + "null";
      } else if (localStorage.message == "null") {
        // console.log(localStorage.message) + "'null'";
      } else {
        this.message = localStorage.message;
      }
    }
  },

  filters: {
    filterPhone: function(str) {
      let cleaned = ("" + str).replace(/\D/g, "");

      //Check if the input is of correct length
      let match = cleaned.match(/^(\d{2})(\d{2})(\d{2})(\d{2})$/);

      if (match) {
        return match[1] + " " + match[2] + " " + match[3] + " " + match[4];
      }

      return null;
    },
  },
  methods: {
    addSnack(text) {
      this.$store.dispatch("snackbar", text);
    },
    async getSaldo() {
      // https://us-central1-smsbase-72fb1.cloudfunctions.net/smssaldo
      try {
        const response = await axios.get(
          `https://us-central1-smsbase-72fb1.cloudfunctions.net/smssaldo`
        );
        this.saldo = response.data;
      } catch (e) {
        console.log(e);
      }

      //  console.log("new Saldo:", this.saldo);
    },
    async send() {
      this.loading = true;

      //  console.log(JSON.parse(this.json));
      if (
        this.selected.length > 0 &&
        this.message.length > 0 &&
        this.sendDate == "now"
      ) {
        axios
          .post(
            `https://us-central1-smsbase-72fb1.cloudfunctions.net/sms`,
            JSON.parse(this.json)
          )
          .then((response) => {
            this.loading = false;
            this.message = "";
            this.selected = [];
            localStorage.message = "";
            this.addSnack({
              showing: true,
              text: "Din besked er sendt!",
              timeout: 4000,
              color: "success",
            });
            //alert("Success", JSON.stringify(response));
            if (response) console.log("Success", response);
            this.getSaldo(response);
          })
          .catch((e) => {
            this.loading = false;
            console.log("Error", JSON.stringify(e));
            this.addSnack({
              showing: true,
              text: "Tjek at alt er som det skal være..." + e,
              timeout: 2000,
              color: "error",
            });
          });
      } else if (
        this.selected.length > 0 &&
        this.message.length > 0 &&
        this.sendDate == "scheduled"
      ) {
        console.log("this.date ", this.date);
        console.log("Date ", new Date(this.date));

        console.log("now ", new Date());
        console.log("...");
        console.log(new Date(this.date) < new Date());
        if (
          new Date(moment(this.date, moment.defaultFormat).toDate()) <
          new Date()
        ) {
          console.log("loading:... ", this.loading);

          // ^^^virker ikke ^^^^^
          this.loading = false;
          this.addSnack({
            showing: true,
            text: "Vælg et afsendingstidspunkt, der ligger i fremtiden.",
            timeout: 2000,
            color: "error",
          });
        } else {
          console.log("loading: ", this.loading);
          var self = this;
          db.collection("scheduledSMS")
            .add(this.plannedMsg)
            .then((docRef) => {
              console.log("Document written with ID: ", docRef.id);
              //console.log("loading: ", this.loading);
              this.loading = false;
              this.message = "";
              this.selected = [];
              this.sendDate = "now";
              this.date = null;
              localStorage.message = "";

              self.addSnack({
                showing: true,
                text: "Din besked er nu planlagt til at blive sendt.",
                timeout: 4000,
                color: "success",
              });
            })
            .catch(function(error) {
              console.error("Error adding document: ", error);
            });
        }
      } else {
        this.loading = false;
        this.addSnack({
          showing: true,
          text:
            "Tjek venligst, om besked, modtagere og afsendere er, som de skal være.",
          timeout: 2000,
          color: "error",
        });
      }
    },
    selectAll() {
      if (this.selected.length == this.activePersons.length) {
        this.selected = [];
      } else {
        this.selected = this.activePersons;
      }
    },
  },
  computed: {
    formatDate() {
      return moment(this.date2).format("YYYY-MM-DD HH:mm");
    },
    user() {
      return this.$store.getters.user;
    },
    persons() {
      if (!this.$attrs.classData.id) {
        return null;
      }

      return this.$store.getters.profilesByClass(this.$attrs.classData.id);
    },
    activePersons: function() {
      if (!this.persons) {
        return null;
      }
      return this.persons.filter(function(p) {
        return p.active;
      });
    },
    filteredPeople() {
      // If there is no filter text, just return everyone
      if (!this.filterText) return this.liste;

      // Convert the search text to lower case
      let searchText = this.filterText.toLowerCase();

      // Use the standard javascript filter method of arrays
      // to return only people whose first name or last name
      // includes the search text
      return this.liste.filter((p) => {
        // if IE support is required and not pre-compiling,
        // use indexOf instead of includes
        return (
          p.fornavn.toLowerCase().includes(searchText) ||
          p.efternavn.toLowerCase().includes(searchText)
        );
      });
    },
    modtagere() {
      var modtager = [];

      this.selected.forEach((select) => {
        var recipient = {
          msisdn: select.number.toString(),
          tagvalues: [select.firstName, select.lastName, select.id],
        };
        modtager.push(recipient);
      });

      return modtager;
    },
    formattedDate() {
      var formattedDate = new Date(this.date).toISOString();
      return formattedDate;
    },
    json() {
      var message = "";
      if (this.afsender == this.user.number) {
        message = this.message;
      } else {
        message = `${this.message} ${this.warning}`;
      }

      var tags = [];
      for (let tag of this.tags) {
        tags.push(tag.tag);
      }
      var jsoncontent = {
        sender: this.afsender.toString(),
        message: message,
        recipients: this.modtagere,
        tags: tags, //["%navn%", "%efternavn%"]
      };

      return JSON.stringify(jsoncontent);
    },
    plannedMsg() {
      //  moment("").isValid()
      console.log(this.date);
      console.log("Valid moment? ", moment(this.date).isValid());
      console.log(
        "Valid moment? ",
        moment(this.date, moment.defaultFormat).toDate()
      );

      var newDate = firebase.firestore.Timestamp.fromDate(
        new Date(moment(this.date, moment.defaultFormat).toDate())
      ); //this.date

      var message = {
        json: JSON.parse(this.json),
        sent: false,
        date: newDate,
        class: this.$attrs.classData.id,
      };
      return message;
    },
  },
};
</script>

<style lang="scss" scoped>
tbody tr:nth-of-type(odd) {
  background-color: rgba(0, 0, 0, 0.05);
}
</style>
